import type { OnStateChange } from "@/components/mosaic/ui/TileTitle/TileTitle";
import type {
	AnalystsEstimatesChartTimeFrame,
	AnalystsEstimatesChartViewMode,
	RevisionExt,
} from "@/components/widgets/Revision/types";
import { COMPONENT_CONTAINER_CLASSES } from "../../../config";
import { DispersionLightweightChart } from "./ui/components";

export const Estimates = ({
	data,
	analystsEstimatesChartTimeFrame,
	analystsEstimatesChartViewMode,
	onStateChange,
}: {
	data?: RevisionExt[];
	analystsEstimatesChartTimeFrame: AnalystsEstimatesChartTimeFrame;
	analystsEstimatesChartViewMode: AnalystsEstimatesChartViewMode;
	onStateChange?: OnStateChange;
}) => {
	return (
		<div className={COMPONENT_CONTAINER_CLASSES}>
			<h3 className="text-light-gray text-lg">Analysts Estimates Consensus</h3>
			{data?.length ? (
				<DispersionLightweightChart
					data={data}
					analystsEstimatesChartTimeFrame={analystsEstimatesChartTimeFrame}
					analystsEstimatesChartViewMode={analystsEstimatesChartViewMode}
					onStateChange={onStateChange}
				/>
			) : (
				<p className="text-gray-500 mt-2">No ticker data available</p>
			)}
		</div>
	);
};
